import { takeLatest, put, call } from 'redux-saga/effects';
import {
    FETCH_CREDIT_USAGE_DETAILS,
    fetchCreditUsageDataSuccess,
    fetchCreditUsageDataFailure,
    DOWNLOAD_CREDIT_USAGE,
    downloadCreditUsageDataSuccess,
    downloadCreditUsageDataFailure,
    FETCH_CREDIT_USAGE_GRAPH_TILE_DETAILS,
    fetchCreditUsageGraphTileDataSuccess,
    fetchCreditUsageGraphTileDataFailure,
    FETCH_PRODUCT_NAME,
    fetchProductNameDataSuccess,
    fetchProductNameDataFailure
} from './action';
import { HTTP_HEADERS, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';
import { CORE_API } from '../../config';

export function* fetchCreditUsageDataAPIHit(action) {
    let requestUrl = `${CORE_API}/credits/reportmetadata/page/${action.data.pageNumber}/${action.data.pageSize}/sort/${action.data.sortfield}/${action.data.sortDirection}`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.data.fetchData, method: 'POST', headers: HTTP_HEADERS });
        yield put(fetchCreditUsageDataSuccess(listResult));
    } catch (error) {
        yield put(fetchCreditUsageDataFailure(error))
    }
}

export function* fetchCreditUsageData() {
    yield takeLatest(FETCH_CREDIT_USAGE_DETAILS, fetchCreditUsageDataAPIHit);
}

export function* fetchCreditUsageDownloadDataAPIHit(action) {
    let requestUrl = `${CORE_API}/credits/reportmetadata/download`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: { 'Content-Type': 'application/json' }, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadCreditUsageDataSuccess(listResult));
    } catch (err) {
        yield put(downloadCreditUsageDataFailure(err))
    }
}

export function* downloadCreditUsageData() {
    yield takeLatest(DOWNLOAD_CREDIT_USAGE, fetchCreditUsageDownloadDataAPIHit);
}

export function* fetchCreditUsageGraphTileDataAPIHit(action) {
    let requestUrl = `${CORE_API}/credits/view`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchCreditUsageGraphTileDataSuccess(listResult));
    } catch (err) {
        yield put(fetchCreditUsageGraphTileDataFailure(err))
    }
}

export function* fetchCreditUsageGraphTileData() {
    yield takeLatest(FETCH_CREDIT_USAGE_GRAPH_TILE_DETAILS, fetchCreditUsageGraphTileDataAPIHit);
}

export function* getProductNameList(action) {

    let requestUrl = `${CORE_API}/portfolio/filter/product`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });//yield call(Axios.get, requestURL, { headers: httpHeaders });
        // let result = ['QUICK','BUSINESS','COMPREHENSIVE'
        //     // { 
        //     //     name:'QUICK',
        //     //     id:'1'
        //     // },
        //     // { 
        //     //     name:'BUSINESS',
        //     //     id:'2'
        //     // },
        //     // { 
        //     //     name:'COMPREHENSIVE',
        //     //     id:'3'
        //     // }
        // ]
        yield put(fetchProductNameDataSuccess(result));
    } catch (err) {

        yield put(fetchProductNameDataFailure(err))
    }
}

export function* fetchProductNameData() {
    yield takeLatest(FETCH_PRODUCT_NAME, getProductNameList);
}

